import Box from '@mui/material/Box'
import Icon from '@mui/material/Icon'
import Typography from '@mui/material/Typography'
import React from 'react'

import { Checkbox } from '@/app/component/atom/form'
import CustomTooltip from '@/app/component/atom/tooltip'

type Props = {
  disabledText?: string
  registerTemplate: boolean

  onChange: (value: boolean) => void
}

const WhatsappTemplateCheckbox: React.FC<Props> = ({ disabledText, registerTemplate, onChange }) => (
  <Checkbox
    disabledText={disabledText}
    editable={!disabledText}
    label={
      <Typography
        color="textSecondary"
        component="span"
        sx={{ alignItems: 'center', display: 'inline-flex', gap: 0.5 }}
      >
        Send as a WhatsApp Template to use outside the 24-hour message window. (Registers automatically if not yet
        registered.)
        <CustomTooltip title="Registering usually takes a few minutes, but can take up to many hours. If rejected, the campaign launch will fail.">
          <Box
            component="span"
            sx={{ display: 'inline-flex', flexShrink: 0 }}
            tabIndex={0}
            onClick={(event) => event.preventDefault()}
          >
            <Icon color="action" fontSize="small">
              info_outline
            </Icon>
          </Box>
        </CustomTooltip>
      </Typography>
    }
    name="registerTemplate"
    value={registerTemplate.toString()}
    onChange={({ value }) => onChange(value === 'true')}
  />
)

export default WhatsappTemplateCheckbox
